module.exports = "/_next/static/images/FreePlan-sm@2x-1fcad151d868d23187d00a1a3a800e5e.png";